import React from "react";

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import InfoIcon from "@mui/icons-material/Info";

import { useDispatch, useSelector } from "react-redux";
import {
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
  setSelectedDonation,
  getDonationBySearchKey,
} from "../slice";

import Pagination from "@mui/material/Pagination";
import { DonationStatus, EntityType } from "../../../common/enum";
import SvgIconStyle from "../../../components/SvgIconStyle";
import CollectionDonationCard from "../../../components/CollectionDonationCard";
import { Grid } from "@mui/material";
import Filter from "./Filter";
import { getProductList } from "../../DonationView/slice";
import OrderDonation from "./OrderDonation";
import DistanceFilter from "./DistanceFilter";
import Loader from "../../../components/Loader";
import ViewMoreCard from "./ViewMoreCard";
import AlternativeChannel from "./AlternativeChannel";
import SearchByCodDoacao from "./SearchByCodDoacao";
import Button from "@mui/material/Button";
const mainBoxStyles = { display: "flex", justifyContent: "space-between" };

const avataStyles = { bgcolor: "#E4F2E8", width: "58px", height: "58px" };

const svgIconStyle = { color: "black", width: "40px", height: "40px" };

const CollectorDonationView = ({ t }) => {
  const dispatch = useDispatch();
  const {
    dashboardInfo: {
      loading,
      myActiveDonations,
      myActiveDonationsTotalCount,
      myActiveDonationsPage,
      myActiveDonationsOffSet,
      dayExpiryDonationsCount,
      CountExpiredDate,
    },
    auth: {
      profile: { entity, address, favoriteProducts},
    },
    donationCart: { productList },
  } = useSelector((state) => state);
  var donorFilterObj = {
    donor: false,
    event: false,
  };
  var orderByObj = {
    nearest: true,
    nearestExpiry: false,
  };
  var alternativeChannelObj = {
    offerAvialable: true,
    offerEnable: false
  };
  var seeOrderObj = {
    all: true,
    onlyFaviorate: false,
    onlyAssigned: false,
  };
  const distanceFilterObj = {
    offerDistance: false,
    location: false,
  };

  const productGroupObj = React.useMemo(() => {
    return Object.assign(
      {},
      ...productList.map((item) => ({ [item.productGroup]: false }))
    );
  }, [productList]);

  const [donorFilter, setDonorFilter] = React.useState(donorFilterObj);
  const [productFilter, setProductFilter] = React.useState(productGroupObj);
  const [orderCheck, setOrderCheck] = React.useState(orderByObj);
  const [alternativeChannelCheck, setAlternativeChannelCheck] = React.useState(
    alternativeChannelObj
  );
  const [seeOrderCheck, setSeeOrderCheck] = React.useState(seeOrderObj);
  const [totalResultadosGrid, settotalResultadosGrid] = React.useState(0);
  const [distanceFilterCheck, setDistnaceFilterCheck] =
    React.useState(distanceFilterObj);
  const [selectDistrict, setSelectDistrict] = React.useState(null);
  const [selectCounty, setSelectCounty] = React.useState([]);
  var [distance, setDistance] = React.useState(0);
  const [idValue, setIdValue] = React.useState(null);
  const [morePageData,setMorePageData] = React.useState({})
const [filtersInitialized, setFiltersInitialized] = React.useState(false);
  const setOrderCheckValue = React.useCallback((value) => {
    setOrderCheck(value);
  }, []);
  const setAlternativeCheckValue = React.useCallback((value) => {
    setAlternativeChannelCheck(value);
  }, []);
  const setSeeOrderCheckValue = React.useCallback((value) => {
    setSeeOrderCheck(value);
  }, []);

  const setDonorFilterValue = React.useCallback((value) => {
    setDonorFilter(value);
  }, []);

  const setProductFilterValue = React.useCallback((value) => {
    setProductFilter(value);
  }, []);

  React.useEffect(() => {
    const loadProducts = async () => {
      dispatch(getProductList());
    };
    loadProducts();
  }, []);

  React.useEffect(() => {
    if (!donorFilter.donor || (donorFilter.donor && donorFilter.event)) {
      setProductFilter(productGroupObj);
    }
  }, [donorFilter]);

  const getDonations = React.useCallback((payload, limit, offset, page) => {
    dispatch(getMyActiveDonation(payload));
    // dispatch(setMyActiveDonationsLimit(limit));
    // dispatch(setMyActiveDonationsOffset(offset));
    dispatch(setMyActiveDonationsPage(page));
  }, []);

    React.useEffect(() => {
  changeFilters();
}, [selectDistrict, selectCounty]);

  const getDonationPayload = React.useCallback(
    ( offset, limit, value ) => {
      let data = {
        offset: offset,
      limit: limit,
      isNearestExpiry: orderCheck.nearestExpiry,
      lat:
        orderCheck.nearest || distanceFilterCheck.offerDistance
          ? address[0].latitude
          : null,
      lngt:
        orderCheck.nearest || distanceFilterCheck.offerDistance
          ? address[0].longitude
          : null,
      isNearestLocation:
        orderCheck.nearest || distanceFilterCheck.offerDistance,
      dist: distanceFilterCheck.offerDistance ? distance : 0,
      district: distanceFilterCheck.location ? selectDistrict : null,
      county: distanceFilterCheck.location ? selectCounty : null,
      // isAnimal: alternativeChannelCheck.offerAvialable ? `${true}` : ``,
      isDonationAvailble: alternativeChannelCheck.offerAvialable,
      isInvitedByBeneficiary : seeOrderObj.onlyAssigned,
      isFavorite: seeOrderObj.onlyFaviorate,
      entityId: entity?.entityId,
      entityType:
        entity?.entityType === EntityType.donorDistributor
          ? EntityType.distributor
          : entity?.entityType,
      };
      if (donorFilter.donor || donorFilter.event) {
        let isEvent = donorFilter.event ? true : false;
        data["isEvent"] = donorFilter.donor && donorFilter.event ? null : isEvent;
      } 
      //console.log(data);
      setMorePageData(data)
      getDonations(data, limit, offset, value);
    },
    [
      donorFilter,
      orderCheck,
      distanceFilterCheck,
      distance,
      selectDistrict,
      selectCounty,
    ]
  );

  React.useEffect(() => {
    if(idValue && idValue.length>4){
      const removeYear = idValue.slice(4);
      const userType = entity?.entityType
      const values = {donationId : parseInt(removeYear) , userType: userType , entityId: entity?.entityId}
      dispatch(getDonationBySearchKey(values))
    }else if(idValue != null && idValue.length== 0){
    changeFilters();
    }

  }, [
    idValue
  ]);

  // React.useEffect(() => {
  //     let limit = 8;
  //     let offset = 0;
  //     let page = 1;
  //     let data = {
  //       offset: offset,
  //       limit: limit,
  //       isNearestExpiry: orderCheck.nearestExpiry,
  //       lat:
  //         orderCheck.nearest || distanceFilterCheck.offerDistance
  //           ? address[0].latitude
  //           : null,
  //       lngt:
  //         orderCheck.nearest || distanceFilterCheck.offerDistance
  //           ? address[0].longitude
  //           : null,
  //       isNearestLocation:
  //         orderCheck.nearest || distanceFilterCheck.offerDistance,
  //       dist: distanceFilterCheck.offerDistance ? distance : 0,
  //       district: distanceFilterCheck.location ? selectDistrict : null,
  //       county: distanceFilterCheck.location ? selectCounty : null,
  //       // isAnimal: alternativeChannelCheck.offerAvialable ? `${true}` : ``,
  //       isFavorite: seeOrderCheck.onlyFaviorate,
  //       isDonationAvailble: alternativeChannelCheck.offerAvialable,
  //       isInvitedByBeneficiary : seeOrderCheck.onlyAssigned,
  //       entityId: entity?.entityId,
  //       entityType:
  //         entity?.entityType === EntityType.donorDistributor
  //           ? EntityType.distributor
  //           : entity?.entityType,
  //     };
  //     if (donorFilter.donor || donorFilter.event) {
  //       let isEvent = donorFilter.event ? true : false;
  //       data["isEvent"] = donorFilter.donor && donorFilter.event ? null : isEvent;
  //       getDonations(data, limit, offset, page);
  //     } else {
  //       getDonations(data, limit, offset, page);
  //     }
  //     setMorePageData(data)
    
    
  // }, [
  //   donorFilter,
  //   // orderCheck,
  //   // seeOrderCheck,
  //   // distanceFilterCheck,
  //   // distance,
  //   // selectDistrict,
  //   // alternativeChannelCheck,
  //   // selectCounty,
  // ]);


  const handleDistanceChange = (event) => {
    setDistance(event.target.value < 1 ? 1 : event.target.value);
    changeFilters();
  };

  const onAdd = () => {
    setDistance((prev) => Number(prev) + 1);
    distance = Number(distance) + 1
    changeFilters();
  };

  const onSubtract = () => {
    setDistance((prev) => (prev === 1 || prev === 0 ? 1 : Number(prev) - 1));
     distance = distance === 1 || distance === 0 ? 1 : Number(distance) - 1
     
    changeFilters();
  };
   
const handleSeeOrderChange = (event) => {
    if (event.target.name === 'all') {
      seeOrderObj = ({ all: true, onlyFaviorate: false, onlyAssigned: false });
    } else if (event.target.name === 'onlyFaviorate') {
      seeOrderObj = ({ all: false, onlyFaviorate: true, onlyAssigned: false });
    } else {
      seeOrderObj = ({ all: false, onlyFaviorate: false, onlyAssigned: true });
    }
  if (event.target.name === 'all') {
    setSeeOrderCheck({ all: true, onlyFaviorate: false, onlyAssigned: false });
  } else if (event.target.name === 'onlyFaviorate') {
    setSeeOrderCheck({ all: false, onlyFaviorate: true, onlyAssigned: false });
  } else {
    setSeeOrderCheck({ all: false, onlyFaviorate: false, onlyAssigned: true });
  }
changeFilters();

  };

  const handleOrderChange = (event) => {
    var whatcheck;
    if([event.target.name] == 'nearest'){
      setOrderCheck({
        ...orderByObj,
        ['nearest']: true,
        ['nearestExpiry']: false
      });
      orderByObj = ({ nearest: true, nearestExpiry: false});
    }else{
      setOrderCheck({
        ...orderByObj,
        ['nearest']: false,
        ['nearestExpiry']: true
      });
      orderByObj = ({ nearest: false, nearestExpiry: true});
    }
    changeFilters();
  };

  const handleOrderChangeAlternative = (event) => {
    if([event.target.name] == 'offerEnable'){
      setAlternativeChannelCheck({
        ...alternativeChannelObj,
        ['offerEnable']: true,
        ['offerAvialable']: false
      });
      alternativeChannelObj = ({ offerAvialable: false, offerEnable: true});
    }else{
      setAlternativeChannelCheck({
        ...alternativeChannelObj,
        ['offerEnable']: false,
        ['offerAvialable']: true
      });
      alternativeChannelObj = ({ offerEnable: false, offerAvialable: true});
    }
    changeFilters();
  };

    const changeFilters = () => {
      let limit = 8;
      let offset = 0;
      let page = 1;
      let data = {
        offset: offset,
        limit: limit,
        isNearestExpiry: orderByObj.nearestExpiry,
        lat:
          orderByObj.nearest || distanceFilterCheck.offerDistance
            ? address[0].latitude
            : null,
        lngt:
          orderByObj.nearest || distanceFilterCheck.offerDistance
            ? address[0].longitude
            : null,
        isNearestLocation:
          orderByObj.nearest || distanceFilterCheck.offerDistance,
        dist: distanceFilterCheck.offerDistance ? distance : 0,
        district: distanceFilterCheck.location ? selectDistrict : null,
        county: distanceFilterCheck.location ? selectCounty : null,
        // isAnimal: alternativeChannelCheck.offerAvialable ? `${true}` : ``,
        isFavorite: seeOrderObj.onlyFaviorate,
        isDonationAvailble: alternativeChannelObj.offerAvialable,
        isInvitedByBeneficiary : seeOrderObj.onlyAssigned,
        entityId: entity?.entityId,
        entityType:
          entity?.entityType === EntityType.donorDistributor
            ? EntityType.distributor
            : entity?.entityType,
      };
      if (donorFilterObj.donor || donorFilterObj.event) {
        let isEvent = donorFilterObj.event ? true : false;
        data["isEvent"] = donorFilterObj.donor && donorFilterObj.event ? null : isEvent;
        getDonations(data, limit, offset, page);
      } else {
        getDonations(data, limit, offset, page);
      }
      setMorePageData(data)
  }

  var collectionDonation = React.useMemo(() => {
    if (myActiveDonations.length > 0) {
      let value = myActiveDonations;
      if (
        productFilter !== undefined &&
        donorFilter.donor &&
        !donorFilter.event
      ) {
        const isFilterProduct = Object.keys(productFilter).some(
          (item) => productFilter[item] === true
        );
        if (isFilterProduct) {
          value = value.filter((item) => {
            if (
              item?.donationProducts.length > 0 &&
              item?.donationProducts.some(
                (p) => productFilter[p.productGroup] === true
              ) 
            ) {
              return item;
            }
          });
        }
      }
      // if (seeOrderCheck.onlyFaviorate) {
      //   value = value.filter((item) => {
      //     if (
      //       item?.donationProducts.length > 0 &&
      //       item?.donationProducts.filter((p) =>
      //         favoriteProducts.find(
      //           (product) => product.productId == p.productId
      //         )
      //       ).length > 0
      //     ) {
      //       return item;
      //     }
      //   });
      // }
      // if(seeOrderCheck.onlyAssigned){
      //   value = value.filter((item) => {
      //      {
      //       return item;
      //     }
      //   });
      // }
      settotalResultadosGrid(myActiveDonationsTotalCount)
      return value;
    } else {
      settotalResultadosGrid(myActiveDonationsTotalCount) 
      return myActiveDonations;
    }
  }, [myActiveDonations, donorFilter, productFilter, seeOrderCheck]);


  const isCounty = React.useMemo(() => {
    var isInCollectionDonation = [];
    if(collectionDonation?.length > 0){
      collectionDonation?.map((listItem, index) => (
        distanceFilterCheck.location == true  && selectDistrict != null && selectCounty.length > 0 ?
        selectDistrict == listItem?.addresses[0].district &&
        selectCounty.map(element => {
         if(element == listItem?.addresses[0].county){
          isInCollectionDonation.push(listItem)
         }
        })
        : isInCollectionDonation
      ))

      if(selectDistrict != null && selectCounty.length > 0){
        collectionDonation = isInCollectionDonation;
      }
       
    }

  })

 
  //console.log(isCounty)
  

  const dayExpiryDonationsCount2 = React.useMemo(() => {
    if(collectionDonation?.length > 0){
      var donationexpiredday = collectionDonation.filter(expiredday => new Date(expiredday.donation.expiryDate).getDate() ==  new Date().getDate())
    }else{
      var donationexpiredday = [];
    }
   
    return donationexpiredday.length;
  }, [CountExpiredDate]);

  const totalPageCount = React.useMemo(() => {
    return Math.ceil(myActiveDonationsTotalCount > 0 ? ((myActiveDonationsTotalCount - 1) / 8) : 0);
  }, [myActiveDonationsTotalCount]);

  const totalPageCountResults = React.useMemo(() => {
    var pagesdivider = Math.ceil(myActiveDonationsTotalCount / 8)
   
    return myActiveDonationsTotalCount - pagesdivider;
  });
  const handleChange = (event, value) => {
    // const incremento = value === 1 ? 8 : 9;
    // const page = value; // Página ativa

    // const start = (page - 1) * incremento; 
    // const end = start + incremento; 
    

    // let offset = start
    // let limit = end

    const page = value;

    let offset;
    let limit;

    if (page === 1) {
      offset = 0;
      limit = 8;
    } else {
      offset = 8 + (page - 2) * 9;
      limit = 8 + (page - 1) * 9;
    }

    const data = {
      offset: offset,
      limit: limit,
      isNearestExpiry: orderCheck.nearestExpiry,
      isInvitedByBeneficiary : seeOrderObj.onlyAssigned,
      lat:
        orderCheck.nearest || distanceFilterCheck.offerDistance
          ? address[0].latitude
          : null,
      lngt:
        orderCheck.nearest || distanceFilterCheck.offerDistance
          ? address[0].longitude
          : null,
      isNearestLocation:
        orderCheck.nearest || distanceFilterCheck.offerDistance,
      dist: distanceFilterCheck.offerDistance ? distance : 0,
      district: distanceFilterCheck.location ? selectDistrict : null,
      county: distanceFilterCheck.location ? selectCounty : null,
      // isAnimal: alternativeChannelCheck.offerAvialable ? `${true}` : ``,
      isDonationAvailble: alternativeChannelCheck.offerAvialable,
      entityType:
        entity?.entityType === EntityType.donorDistributor
          ? EntityType.distributor
          : entity?.entityType,
    };

    data["entityId"] = entity.entityId;
    setMorePageData(data)
    getDonations(data, limit, offset, value);
  };

  // const handleMoreDataChange = (event, value) => {
  //   var page = myActiveDonationsPage;

  //   getDonationPayload(8, 16,value);
  // };
  const handleMoreDataChange = (event, value) => {
    const incremento = value === 1 ? 0 : 8; // Incremento é 8 na página 1, 9 nas outras
    const page = value; // Página ativa
  
    // Calcular os valores com base na página
    const start = incremento; // Início da faixa
    const end = start + incremento; // Fim da faixa
  
    // Chamar a função com os valores calculados
    getDonationPayload(start, end, value);
  };
  
  const handlePreviousPage = () => {
    if (myActiveDonationsPage > 1) {
      const newPage = myActiveDonationsPage - 1;
      const limit = 12;
      const offset = (newPage - 1) * limit;

      const data = {
        offset: offset,
        limit: limit,
        isNearestExpiry: orderCheck.nearestExpiry,
        isInvitedByBeneficiary: seeOrderObj.onlyAssigned,
        lat:
          orderCheck.nearest || distanceFilterCheck.offerDistance
            ? address[0].latitude
            : null,
        lngt:
          orderCheck.nearest || distanceFilterCheck.offerDistance
            ? address[0].longitude
            : null,
        isNearestLocation:
          orderCheck.nearest || distanceFilterCheck.offerDistance,
        dist: distanceFilterCheck.offerDistance ? distance : 0,
        district: distanceFilterCheck.location ? selectDistrict : null,
        county: distanceFilterCheck.location ? selectCounty : null,
        isDonationAvailble: alternativeChannelCheck.offerAvialable,
        entityType:
          entity?.entityType === EntityType.donorDistributor
            ? EntityType.distributor
            : entity?.entityType,
      };

      data["entityId"] = entity.entityId;
      setMorePageData(data);
      getDonations(data, limit, offset, newPage); 
    }
  };
  const handleChangeFilterType = (event) => { 
    const { name, checked } = event.target;

    donorFilterObj[name] = checked;  

    setDonorFilter({
      ...donorFilterObj,
      [event.target.name]: event.target.checked,
    });

    changeFilters();                  
  };



  return (
    <Stack
      spacing={1}
      sx={{
        p: 1,
        width: 1,
      }}
    >
      <Stack direction={"row"} justifyContent={"flex-end"} gap={2} sx={{
              '@media (max-width:600px)': {
                display: "flex",
                flexDirection: "column"
              }}}>
         <SearchByCodDoacao
          buttonName={"Pesquisar por código de doação"}
          t={t}
          setIdValue={setIdValue}
          idValue={idValue}
        />
        {entity?.entityType === EntityType.specialDistributor && (
          <AlternativeChannel
            buttonName="alternativeChannelHabilito"
            alternativeChannelObj={alternativeChannelObj}
            alternativeChannelChecked={alternativeChannelCheck}
            setAlternativeChannelChecked={setAlternativeCheckValue}
            handleOrderChangeAlternative = {handleOrderChangeAlternative}
            t={t}
          />
        )}
        <OrderDonation
          buttonName={"orderBy"}
          orderByObj={orderByObj}
          orderChecked={orderCheck}
          setOrderChecked={setOrderCheckValue}
          seeOrderObj={seeOrderObj}
          seeOrderChecked={seeOrderCheck}
          setSeeOrderChecked={setSeeOrderCheckValue}
          handleSeeOrderChange={handleSeeOrderChange}
          handleOrderChange = {handleOrderChange}
          t={t}
         
        />
       
        
        <DistanceFilter
          distanceFilterObj={distanceFilterObj}
          distanceFilterCheck={distanceFilterCheck}
          setDistnaceFilterCheck={setDistnaceFilterCheck}
          selectDistrict={selectDistrict}
          setSelectDistrict={setSelectDistrict}
          selectCounty={selectCounty}
          setSelectCounty={setSelectCounty}
          distance={distance}
          setDistance={setDistance}
          handleDistanceChange={handleDistanceChange}
          onAdd={onAdd}
          onSubtract={onSubtract}
          t={t}
        />
        <Filter
          buttonName={"filter"}
          donorFilterObj={donorFilterObj}
          donorFilter={donorFilter}
          setDonorFilterValue={setDonorFilterValue}
          productGroupObj={productGroupObj}
          productFilter={productFilter}
          setProductFilterValue={setProductFilterValue}
          handleChangeFilterType = {handleChangeFilterType}
          t={t}
        />
      </Stack>
      <Grid container spacing={1}>
        {loading && (
          <Loader phrase={"collectionDoanationLoadingPhrase"} t={t} />
        )}
        {!loading && CountExpiredDate > 0 && (
          <Box
            sx={{
              width: 1,
              backgroundColor: "#e5f1ff",
              display: "flex",
              alignItems: "center",
              borderRadius: 1.5,
              p: 1.5,
              my: 2,
              ml: 2,
            }}
          >
            <InfoIcon sx={{ color: "#0167d6" }} />
            <Typography variant="body2" fontWeight={500} mx={2}>
              {CountExpiredDate} {`${t("donationExpireToday")}`}
            </Typography>
            
          </Box>
        )}
        {!loading && collectionDonation?.length > 0 && (
          <>
           
            {collectionDonation?.map((listItem, index) => (
              
              <Grid item xs={12} md={6} lg={4} key={index}>
                <CollectionDonationCard t={t} item={listItem} selectDistrict={selectDistrict} selectCounty={selectCounty} distanceFilterCheck={distanceFilterCheck}/>
              </Grid>
            ))}
            {totalResultadosGrid > 8 && myActiveDonationsPage === 1 && (
              <Grid item xs={12} md={6} lg={4}>
                <ViewMoreCard
                  t={t}
                  offerCount={(myActiveDonationsTotalCount - 8)}
                  handleClick={handleMoreDataChange}
                />
              </Grid>
            )}
          </>
        )}
        {/* Botão Voltar */}
        {/* {myActiveDonationsPage > 1 && (
              <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePreviousPage}
                >
                  Voltar para página anterior
                </Button>
              </Grid>
            )} */}
      </Grid>
      {!loading &&
        myActiveDonations?.length > 0 &&
        myActiveDonationsPage > 1 && (
          <Stack spacing={2} alignItems={"center"}>
            <Pagination
              count={totalPageCount}
              variant="outlined"
              color="primary"
              onChange={handleChange}
              page={myActiveDonationsPage}
            />
          </Stack>
        )}
      {!loading && myActiveDonations.length === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            marginTop: "10% !important"
          }}
        >
          <Avatar sx={avataStyles}>
            <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
          </Avatar>
          <Box sx={{ paddingLeft: "10px" }}>
            <Typography sx={{ marginTop: "10px" }}>
            Sem doações disponíveis.
            </Typography>
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default CollectorDonationView;
